import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import PrivateLayout from '../layout/PrivateLayout/PrivateLayout';
import { useUserContext } from '../contexts/UserContext';

interface PrivateOutletProps {
  displaySideBar: boolean
  displayAccountSideBar?: boolean
  defaultNav: boolean
}

function PrivateOutlet(props: PrivateOutletProps): React.ReactElement {
  const { displaySideBar, displayAccountSideBar, defaultNav } = props;
  const location = useLocation();
  const { isAuthenticated } = useUserContext();
  return isAuthenticated
    ? <PrivateLayout defaultNav={defaultNav} displaySideBar={displaySideBar} displayAccountSideBar={displayAccountSideBar}><Outlet /></PrivateLayout>
    : <Navigate to={`/login?redirect=${location.pathname}`} />;
}

export default PrivateOutlet;
